// extracted by mini-css-extract-plugin
export var imageContainer = "ProfileImage-module--imageContainer--3NQ3N";
export var spark = "ProfileImage-module--spark--32OPT";